import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DataTable from "react-data-table-component";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import UploadIcon from "@mui/icons-material/Upload";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Select from "react-select";
import {
    BASE_URL_INVENTORY,
    DOWNLOAD_ITEM_URL,
    ITEM_URL,
} from "../../../CONSTANTS";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Header } from "antd/lib/layout/layout";
import toast, { Toaster } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import {
    addItemByWarehouseId1, //sync
    removeItemByWarehouseId1, //sync
    activeDeactiveItem,
    activeDeactiveItemByWare,
    uploadExcel,
    getWarehouseKeyValueList,
    updateItem,
    getItemDetail,
    getCategoryKeyValue,
} from "../../../services/index";
import { AuthUrlContext } from "../../../context/createContext";
import PaginationDataTable from "../../Common/PaginationDataTable";
import { Spinner } from "react-bootstrap";
import { callPostApi } from "../../../services/common/common";
import { getWarehouseKeyValueDetailsList, syncWarehouse } from "../../../services/Settings/WarehouseService";

const ItemList = () => {
    let navigate = useNavigate();
    const [itemSync1, setItemSync1] = useState([]);
    const [itemSync2, setItemSync2] = useState([]);
    const [itemExist, setItemExist] = useState([]);
    const [itemExistClone, setItemExistClone] = useState([]);
    const [itemPurchasePrice, setItemPurchasePrice] = useState(0);
    const [itemSalesPrice, setItemSalesPrice] = useState(0);
    const [itemDetail, setItemDetail] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFromWarehouse, setSelectedFromWarehouse] = useState(null);
    const [selectedToWarehouse, setSelectedToWarehouse] = useState(null);
    const [syncWareHouseOption, setSyncWareHouseOptions] = useState([]);

    const [error, setError] = useState({});

    const [show5, setShow5] = useState(false);
    const [showSyncModal, setShowSyncModal] = useState(false);
    const handleClose5 = () => setShow5(false);

    const [show3, setShow3] = useState(false);
    const handleClose3 = () => setShow3(false);

    const handleShow3 = (row) => {
        setShow3(true);
        getItemDetail(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                setItemDetail(res.responsePacket);
            }
        });

        setItemPurchasePrice(row.purchasePriceValue);
        setItemSalesPrice(row.sellingPriceValue);
    };

    const [file1, setFile1] = useState({
        fileBase64: "",
        fileName: "",
    });

    const [isSales, setIsSales] = useState(false);
    const [isPurchase, setIsPurchase] = useState(false);
    const [warehouseOptions, setWarehouseOptions] = useState([]);
    const [fromWareHouseOptions, setFromWareHouseOption] = useState([]);
    const [warehouseOptions3, setWarehouseOptions3] = useState([]);
    const [warehouseName, setWarehouseName] = useState("");
    const [warehouseName3, setWarehouseName3] = useState("");
    const [warehouseId, setWarehouseId] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState("");
    const [showSpinner, setShowSpinner] = useState(false);

    const [rows, setRows] = useState([]);

    const [listState, setListState] = useState("list1");

    const [filteredData2, setFilteredData2] = useState([]);
    const [search2, setSearch2] = useState("");
    const [rows2, setRows2] = useState([]);

    const [filteredData3, setFilteredData3] = useState([]);
    const [rows3, setRows3] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryId, setCategoryId] = useState("");
    const [refreshFlag, setRefreshFlag] = useState(0);
    let userDetail = JSON.parse(localStorage.getItem("userDetail"));
    let userType = userDetail ? userDetail.userType : "";

    useEffect(() => {
        getCategoryKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options.unshift({
                    value: "",
                    label: "Select Category",
                });
                setCategoryOptions(options);
                setSelectedCategory(options[0]);
            }
        });
    }, []);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                name: "NAME",
                cell: (row) => row.title,
            },

            {
                name: "ACTION",
                selector: (row) => (
                    <div>
                        <EditIcon
                            style={{ fontSize: "15px", cursor: "pointer" }}
                            onClick={() => {
                                navigate("/items/" + row.recordId + "/edit");
                            }}
                        />
                        &nbsp;&nbsp;
                        {row.active ? (
                            <CheckCircleIcon
                                style={{
                                    fontSize: "15px",
                                    cursor: "pointer",
                                    color: "greenyellow",
                                }}
                                onClick={() => handleActiveInactive1(row)}
                            />
                        ) : (
                            <CancelIcon
                                style={{
                                    fontSize: "15px",
                                    cursor: "pointer",
                                    color: "tomato",
                                }}
                                onClick={() => handleActiveInactive1(row)}
                            />
                        )}
                    </div>
                ),
            },
        ],
        [handleRefresh, categoryId, warehouseId]
    );

    const handleActiveInactive = (row) => {
        activeDeactiveItemByWare(row.itemId, row.warehouseId).then((res) => {
            if (res.errorCode === 0) {
                let e = {
                    value: row.warehouseId,
                    label: warehouseName.label,
                };
                handleWarehouseChange2(e);
                toast(res.message);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    const handleActiveInactive1 = (row) => {
        activeDeactiveItem(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                // getItemRecords();
                toast(res.message);
                handleRefresh();
            } else {
                toast(res.message);
                return;
            }
        });
    };


    const handleWarehouseChange = (e) => {
        setWarehouseName(e);
        setWarehouseId(e.value);
    };

    const handleWarehouseChange2 = (e) => {
        setWarehouseName(e);
        setWarehouseId(e.value);
    };

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options.unshift({
                    label: "Select Warehouse",
                    value: "",
                });
                setWarehouseOptions(options);
                setWarehouseName(options[0]);
                const options2 = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWarehouseOptions3(options2);
            } else {
                toast(res.message);
            }
        });
    }, [listState]);

    useEffect(() => {
        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setSyncWareHouseOptions(options);
                setSelectedFromWarehouse(options[0]);
                setSelectedToWarehouse(options[options.length - 1]);
            } else {
                toast(res);
            }
        });
    }, []);


    useEffect(() => {
        if (categoryOptions && categoryOptions.length > 0 && selectedCategory) {
            if (listState === "list1") {
                if (selectedCategory.label === "Select Category") {
                    setFilteredData(rows);
                } else {
                    const result = rows.filter((data) => {
                        return data.categoryTitle
                            .toLowerCase()
                            .includes(selectedCategory.label.toLowerCase());
                    });
                    setFilteredData(result);
                }
            } else {
                if (selectedCategory.label === "Select Category") {
                    setFilteredData2(rows2);
                } else {
                    const result = rows2.filter((data) => {
                        return data.categoryTitle
                            .toLowerCase()
                            .includes(selectedCategory.label.toLowerCase());
                    });
                    setFilteredData2(result);
                }
            }
        }
    }, [selectedCategory]);

    useEffect(() => {
        const result = rows.filter((data) => {
            return (
                data.title.toLowerCase().includes(search.toLowerCase()) ||
                data.taxTitleIntrastate
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                data.taxTitleInterstate
                    .toLowerCase()
                    .includes(search.toLowerCase())
            );
        });
        setFilteredData(result);
    }, [search]);

    useEffect(() => {
        const result = rows2.filter((data) => {
            return data.itemTitle.toLowerCase().includes(search2.toLowerCase());
        });
        setFilteredData2(result);
    }, [search2]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleFileRead = async (event) => {
        const file = event.target.files[0];
        const base64 = await convertBase64(file);
        const base = base64.split(",")[1];
        setFile1({
            fileBase64: base,
            fileName: file.name,
        });
    };

    const handleUpload = () => {
        setShowSpinner(true);
        uploadExcel(file1).then((res) => {
            if (res.errorCode === 0) {
                toast("File Uploaded Successfully");
                setShowSpinner(false);
                handleClose();
            } else {
                setError(res);
                setShow5(true);
                setShowSpinner(false);
            }
        }).catch((error) => {
            setError(error);
            setShow5(true);
            setShowSpinner(false);
        });
    };

    const { userRights } = useContext(AuthUrlContext);
    const { urlList, userRole } = userRights;
    let isSuperAdmin = userRole === "ROLE_SUPER_ADMIN";

    const handleWarn = () => {
        alert("Access Denied!");
        return;
    };



    const handlePriceUpdate = () => {
        let data = {
            brandId: itemDetail.categoryId,
            brandTitle: itemDetail.categoryTitle,
            dimensionBreadth: itemDetail.dimensionBreadth,
            dimensionHeight: itemDetail.dimensionHeight,
            dimensionLength: itemDetail.dimensionLength,
            dimensionUnitId: itemDetail.dimensionUnitId,
            dimensionUnitTitle: itemDetail.dimensionUnitTitle,
            hsnId: itemDetail?.hsnId,
            hsnSac: itemDetail?.hsnSac,
            isIngredient: itemDetail?.isIngredient,
            itemTypeEnum: itemDetail?.itemTypeEnum,
            manufacturerId: itemDetail?.manufacturerId,
            manufacturerTitle: itemDetail?.manufacturerTitle,
            isReturnable: itemDetail?.isReturnable,
            sku: itemDetail?.sku,

            isPurchase: isPurchase ? isPurchase : itemDetail?.isPurchase,
            purchasePriceValue: isPurchase
                ? itemPurchasePrice
                : itemDetail?.purchasePriceValue,
            purchaseAccountId: "c83d1e77-2a18-4437-ba21-fef2b2e97abb",
            purchaseAccountTitle: "Expense",
            purchaseAccountTypeEnum: "Expense",
            purchaseDescription: "p",

            isSales: isSales ? isSales : itemDetail?.isSales,
            sellingPriceValue: isSales
                ? itemSalesPrice
                : itemDetail?.sellingPriceValue,
            sellingAccountId: "e0ebbd3e-31bc-43c1-ac36-e01be0801d82",
            sellingAccountTitle: "Income",
            sellingAccountTypeEnum: "Income",
            sellingDescription: "s",

            taxExemptId: itemDetail?.taxExemptId,
            taxExemptTitle: itemDetail?.taxExemptTitle,

            taxIdInterstate: itemDetail?.taxIdInterstate,
            taxIdIntrastate: itemDetail?.taxIdIntrastate,

            taxTitleInterstate: itemDetail?.taxTitleInterstate,
            taxTitleIntrastate: itemDetail?.taxTitleIntrastate,

            isTaxable: itemDetail.isTaxable,

            title: itemDetail.title,
            isIngredient: itemDetail.isIngredient,

            warehouseItemsBeanList: itemDetail.warehouseItemsBeanList,
            weightUnitId: itemDetail.packUnitId,
            weightUnitTitle: itemDetail.packUnitTitle,
            weightValue: itemDetail.weightValue,

            packUnitId: itemDetail.packUnitId,
            packUnitTitle: itemDetail.packUnitTitle,
        };

        updateItem(itemDetail.recordId, data).then((res) => {
            if (res.errorCode === 0) {
                handleClose3();
                setIsPurchase(false);
                setIsSales(false);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    const handlePurchase = (a) => {
        setItemPurchasePrice(a);
    };

    const handleSales = (a) => {
        setItemSalesPrice(a);
    };

    const handleIsPurchase = (e) => {
        setIsPurchase(e.target.checked);
    };

    const handleIsSales = (e) => {
        setIsSales(e.target.checked);
    };

    const handleWarehouseChange3 = (e) => {
        setWarehouseName3(e);
    };

    const handleRemoveSync = () => {
        if (itemSync1.length === 0) {
            toast("please select an item to add");
            return;
        }
        if (itemSync1.length > 0) {
            removeItemByWarehouseId1(warehouseName3.value, itemSync1).then(
                (res) => {
                    if (res.errorCode === 0) {
                        handleWarehouseChange3(warehouseName3);
                        setItemSync1("");
                        toast(res.message);
                    } else {
                        toast(res.message);
                    }
                }
            );
        }
    };

    const handleAddSync = () => {
        if (itemSync2.length === 0) {
            toast("please select an item to remove");
            return;
        }

        addItemByWarehouseId1(warehouseName3.value, itemSync2).then((res) => {
            if (res.errorCode === 0) {
                handleWarehouseChange3(warehouseName3);
                setItemSync2("");
                toast(res.message);
            } else {
                toast.error(res.message, {
                    autoClose: 5000,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
            }
        });
    };

    const colExist = [
        {
            name: "EXISTING ITEMS",
            cell: (row) => row.itemTitle,
        },
    ];

    const colNotExist = [
        {
            name: "NOT EXISTING ITEMS",
            cell: (row) => row.title,
        },
    ];

    //exist
    const handleItem1 = (row) => {
        let abc = row.selectedRows.map((a) => {
            return { itemId: a.itemId, itemTitle: a.itemTitle };
        });
        setItemSync1(abc);
    };

    //not exist
    const handleItem2 = (row) => {
        let abc = row.selectedRows.map((a) => {
            return { itemId: a.recordId, itemTitle: a.title };
        });
        setItemSync2(abc);
    };

    const handleSearch = (e) => {
        const result = rows3.filter((a) => {
            return a.title.toLowerCase().includes(e.target.value.toLowerCase());
        });
        setFilteredData3(result);

        const result2 = itemExistClone.filter((a) => {
            return a.itemTitle
                .toLowerCase()
                .includes(e.target.value.toLowerCase());
        });
        setItemExist(result2);
    };

    const handleRowClick = (e) => {
        if (warehouseId && warehouseId !== "") {
            navigate(`/items/${warehouseId}/${e.recordId}`);
        } else {
            navigate(`/items/${e.recordId}`);
        }
    };

    const handleCategory = (e) => {
        setSelectedCategory(e);
        setCategoryId(e.value);
    }

    const handleSelectWarehouse = (e, type) => {
        if (type === "from") {
            setSelectedFromWarehouse(e);
        } else {
            setSelectedToWarehouse(e)
        }
    };

    const handleItemSync = () => {
        const data = {
            fromWarehouseUUid: selectedFromWarehouse.value,
            toWarehouseUUid: selectedToWarehouse.value,
        }
        syncWarehouse(data).then((res) => {
            if (res.errorCode == 0) {
                toast.success(res.message)
                setShowSyncModal(false)
            } else {
                toast.error(res.message)
                return;
            }
        }).catch(() => {
            toast.error("server error");
            return
        });
    }

    const filter = useMemo(() => ({
        uuid: warehouseId,
        uuid2: categoryId,
    }), [warehouseId, categoryId]);

    return (
        <>
            <>
                <Modal show={show2} onHide={handleClose2} size="lg">
                    <div
                        className="row"
                        style={{
                            padding: "5px",
                            justifyContent: "space-between",
                        }}
                    >
                        <div className="col-4" style={{ zIndex: 6 }}>
                            <Select
                                options={warehouseOptions3}
                                placeholder={"Select WareHouse"}
                                onChange={(e) => handleWarehouseChange3(e)}
                                value={warehouseName3}
                                maxMenuHeight={220}
                            />
                        </div>
                        <div>
                            {filteredData3 && filteredData3.length > 0 ? (
                                <>
                                    Remove
                                    <ArrowBackIosIcon
                                        style={{
                                            color: "#00a2ca",
                                            fontSize: "30px",
                                            cursor: "pointer",
                                        }}
                                        onClick={handleAddSync}
                                    />
                                </>
                            ) : (
                                ""
                            )}
                            {itemExist && itemExist.length > 0 ? (
                                <>
                                    <ArrowForwardIosIcon
                                        style={{
                                            color: "#00a2ca",
                                            fontSize: "30px",
                                            cursor: "pointer",
                                        }}
                                        onClick={handleRemoveSync}
                                    />
                                    Add
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="col-4 d-flex align-items-center">
                            <SearchRoundedIcon />
                            <input
                                autoComplete="off"
                                className="ember-text-field ember-view form-control "
                                type="text"
                                placeholder="Search item "
                                onChange={(e) => handleSearch(e)}
                            />
                        </div>
                    </div>
                    <Modal.Body>
                        <div className="d-flex justify-content-between">
                            <DataTable
                                columns={colExist}
                                data={itemExist}
                                fixedHeader
                                selectableRows
                                onSelectedRowsChange={(rows) =>
                                    handleItem1(rows)
                                }
                            />
                            {filteredData3 && filteredData3.length > 0 ? (
                                <DataTable
                                    columns={colNotExist}
                                    data={filteredData3}
                                    fixedHeader
                                    selectableRows
                                    onSelectedRowsChange={(rows) =>
                                        handleItem2(rows)
                                    }
                                />
                            ) : (
                                ""
                            )}
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={show3} onHide={handleClose3} size="sm">
                    <Modal.Body>
                        <tr>{itemDetail.title}</tr>
                        <br />
                        <table className="customTable">
                            <tr>
                                <td>Purchase Price:</td>&nbsp;&nbsp;&nbsp;
                                <td>
                                    <input
                                        autoComplete="off"
                                        type="checkbox"
                                        value={isPurchase}
                                        onChange={(e) => {
                                            handleIsPurchase(e);
                                        }}
                                    />
                                    <input
                                        autoComplete="off"
                                        style={{ width: "90px" }}
                                        type="number"
                                        value={itemPurchasePrice}
                                        onChange={(e) => {
                                            handlePurchase(e.target.value);
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Selling Price:</td>
                                &nbsp;&nbsp;&nbsp;
                                <td>
                                    <input
                                        autoComplete="off"
                                        type="checkbox"
                                        value={isSales}
                                        onChange={(e) => {
                                            handleIsSales(e);
                                        }}
                                    />
                                    <input
                                        autoComplete="off"
                                        style={{ width: "90px" }}
                                        type="number"
                                        value={itemSalesPrice}
                                        onChange={(e) => {
                                            handleSales(e.target.value);
                                        }}
                                    />
                                </td>
                            </tr>
                        </table>
                        <br />{" "}
                        <Button variant="primary" onClick={handlePriceUpdate}>
                            Update
                        </Button>
                    </Modal.Body>
                </Modal>

                <Modal show={show} onHide={handleClose} size="sm">
                    <Modal.Body className="position-relative">
                        <Select
                            options={warehouseOptions}
                            placeholder={"Select Warehouse"}
                            onChange={(e) => handleWarehouseChange(e)}
                            value={warehouseName}
                        />
                        <hr />
                        <br />
                        <input
                            autoComplete="off"
                            className="ember-text-field ember-view form-control"
                            id="originalFileName"
                            type="file"
                            inputProps={{
                                accept: "image/*, .xlsx, .xls, .csv, .pdf, .pptx, .pptm, .ppt",
                            }}
                            required
                            label="Document"
                            name="originalFileName"
                            onChange={(e) => handleFileRead(e)}
                            size="small"
                            variant="standard"
                        />
                    </Modal.Body>

                    <Modal.Footer style={{ zIndex: showSpinner ? 1000 : 100 }}>
                        {(isSuperAdmin || (urlList && urlList.has("/items/downloadItemExcel/{warehouseId}"))) ? (
                            <a
                                style={{ paddingRight: "15px" }}
                                href={`${BASE_URL_INVENTORY}${DOWNLOAD_ITEM_URL}${warehouseId}`}
                                target="_blank"
                                download
                            >
                                {warehouseId ? (
                                    <Button variant="primary">
                                        <DownloadIcon />
                                        Download
                                    </Button>
                                ) : (
                                    <></>
                                )}
                            </a>
                        ) : (
                            <Button
                                id="downloadBtn"
                                variant="secondary"
                                style={{ color: "red" }}
                                onClick={handleWarn}
                            >
                                <DownloadIcon />
                                Download
                            </Button>
                        )}
                        {(isSuperAdmin || (urlList && urlList.has("/items/uploadItemsExcel"))) ? (
                            <Button variant="primary" onClick={handleUpload} className="d-flex align-items-center">
                                {showSpinner ? (
                                    <Spinner
                                        className="costomLoader mr-2"
                                        animation="border"
                                        size="sm"
                                    />
                                ) : (
                                    <UploadIcon />
                                )}
                                Upload
                            </Button>
                        ) : (
                            <Button variant="secondary" onClick={handleWarn}>
                                <UploadIcon /> Upload
                            </Button>
                        )}
                    </Modal.Footer>

                </Modal>

                <Modal show={show5} onHide={handleClose5}>
                    <Modal.Body>
                        <div>
                            {" "}
                            {error.message
                                ? error.message
                                : "Error In Uploading"}
                        </div>
                        <br />
                        {error.listOfErrors ? "List Of ERRORS :" : ""}
                        {error.listOfErrors &&
                            error.listOfErrors?.map((item, i) => {
                                return (
                                    <div key={i}>
                                        {item}
                                        <hr />
                                    </div>
                                );
                            })}
                    </Modal.Body>
                </Modal>
                <Modal show={showSyncModal} onHide={() => setShowSyncModal(false)} size="md" >
                    <Modal.Body style={{ minHeight: "150px" }}>
                        <div className="d-flex mt-2">
                            <div className="d-flex align-items-center pl-3 mr-3">
                                <div className="mr-4">From Warehouse:</div>
                                <div style={{ minWidth: "200px" }}>
                                    <Select
                                        value={selectedFromWarehouse}
                                        id="fromWarehouse"
                                        options={syncWareHouseOption}
                                        onChange={(e) => handleSelectWarehouse(e, "from")}
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center pl-3">
                                <div className="mr-4"> To Warehouse:</div>
                                <div style={{ minWidth: "200px" }}>
                                    <Select
                                        value={selectedToWarehouse}
                                        id="toWarehouse"
                                        options={syncWareHouseOption}
                                        onChange={(e) => handleSelectWarehouse(e, "to")}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleItemSync}>
                            Item Sync
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
            <div className="vendorlistDataTable" style={{ height: 500, width: "100%", zIndex: "-3" }}>
                <div className="excel-postn mt-2">
                    <div className="d-flex align-items-center">
                        <div>
                            <Button variant="primary" onClick={handleShow}>
                                <ImportExportIcon /> Excel
                            </Button>
                        </div>
                        <span className="btn btn-primary mr-2">
                            <Link
                                to={"/items/new"}
                                className="d-flex align-items-center"
                                style={{ color: "#fff" }}
                            >
                                <svg
                                    version="1.1"
                                    id="Layer_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0"
                                    y="0"
                                    viewBox="0 0 512 512"
                                    xmlSpace="preserve"
                                    className="icon icon-xsmall align-text-bottom"
                                >
                                    <path d="M484 227H284V28c0-15.5-12.5-28-28-28s-28 12.5-28 28v199H28c-15.5 0-28 12.5-28 28v1c0 15.5 12.5 28 28 28h200v200c0 15.5 12.5 28 28 28s28-12.5 28-28V284h200c15.5 0 28-12.5 28-28v-1c0-15.5-12.5-28-28-28z"></path>
                                </svg>
                                &nbsp;New
                            </Link>
                        </span>
                        {(userType === "ROLE_SUPER_ADMIN"||isSuperAdmin || (urlList && urlList.has("/warehouseItems/itemSync")))&&
                        <div>
                            <Button variant="primary" onClick={() => setShowSyncModal(true)}>
                                <SyncIcon /> Sync
                            </Button>
                        </div>}
                    </div>
                </div>
                <div className="d-flex align-items-center search-position" style={{ top: "15px" }}>
                    <div
                        id="ember1611"
                        className="dropdown ember-view clearfix mr-3"
                        style={{ zIndex: "6", minWidth: "250px" }}
                    >
                        <Select
                            options={warehouseOptions}
                            placeholder={"Select WareHouse"}
                            onChange={(e) => handleWarehouseChange2(e)}
                            value={warehouseName}
                            maxMenuHeight={220}
                        />
                    </div>
                    <span style={{ zIndex: "6", minWidth: "250px" }}>
                        <Select
                            options={categoryOptions}
                            placeholder={"Select Category"}
                            onChange={(e) => handleCategory(e)}
                            value={selectedCategory}
                            maxMenuHeight={220}
                        />
                    </span>
                </div>

                <PaginationDataTable
                    paginationUrl={ITEM_URL() + "getAllRecords"}
                    serverSidePagination={true}
                    search={true}
                    pagination={false}
                    className="position-relative"
                    columns={columns}
                    showNewBtn={true}
                    onRowClicked={handleRowClick}
                    filter={filter}
                />
            </div>
            <Toaster />
        </>
    );
};

export default ItemList;
